import Icon from '../components/Icon.vue'

Icon.register({
  skiing: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M432 96C458.5 96 480 74.5 480 48S458.5 0 432 0 384 21.5 384 48 405.5 96 432 96zM505 452.1C495.6 442.7 480.4 442.7 471.1 452.1 459 464.2 440.6 467.5 426 460.8L290.2 390.6 339.4 316.8C352.1 297.8 349.6 272.3 333.4 256.2L293 215.7 186 162.6C183.1 182.5 189.4 202.6 203.7 217L278.8 292.2 232.9 361 35 258.7C23.3 252.7 8.8 257.2 2.7 269-3.4 280.8 1.2 295.3 13 301.3L404.9 503.8C416.8 509.3 429.4 511.9 442 511.9 465.2 511.9 488 502.9 505 485.9 514.3 476.6 514.3 461.4 505 452.1zM120 91.6L108.5 114.1C122.9 121.4 139.7 119 151.3 109.3L198.5 132.7C198.4 132.8 198.4 132.9 198.3 133L312.8 189.8 345.2 176.8 351.6 195.9C355.6 208 364.2 217.9 375.6 223.6L433.7 252.6C449.6 260.5 468.7 254.1 476.6 238.3 484.5 222.5 478.1 203.3 462.3 195.4L410.2 169.3 393.1 118.1C385 93.9 352.2 61.5 308.6 78.9L227.4 111.4 164.9 80.4C165.2 65.9 157.7 51.8 144 44.8L132.9 66.5H132.7L98.3 59.5C96.5 59.1 94.6 59.7 93.3 61.2 91.4 63.4 91.6 66.7 93.8 68.6L120 91.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/skiing.js
// module id = NBbV
// module chunks = 144